import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot, Root } from 'react-dom/client';
import { getPortalAlias } from './Services/common';
import { TCustomAdminConfig, ICustomAdminConfigMap } from './Types/custom';

//moving queryClient to FrontEndReact causes problems because they use different react-query-library locations.
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false
		},
	},
});

export function AddBizReactLoader(root: Root | undefined, rootId: string, getApp: (e: CustomEvent) => React.ReactNode) {
	const loadEventName = `Load-${rootId}`;
	document.addEventListener(loadEventName, ((e: CustomEvent) => {
		console.log(loadEventName, root);
		if (!root) {
			const container = document.getElementById(rootId);
			root = createRoot(container!);
		}
		const app = getApp(e);
		root.render(
			<QueryClientProvider client={queryClient}>
				{app}
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
		);
	}) as EventListener);

	const unloadEventName = `Unload-${rootId}`;
	document.addEventListener(unloadEventName, () => {
		console.log(unloadEventName, root);
		if (root) {
			root.unmount();
			root = undefined;
		}
	});
}

export async function GetCustomConfig<T extends keyof ICustomAdminConfigMap>(
	configType: T
): Promise<ICustomAdminConfigMap[T] | undefined> {
	const { configs }: { configs: TCustomAdminConfig[] } = await import(
		`customers/${getPortalAlias()}/React/Admin/customComponentIndex.ts`
	);
	if (!configs) return undefined;

	const config = configs.find((c) => c.type === configType);
	if (!config) return undefined;
	return config?.config as ICustomAdminConfigMap[T];
}
